<input type="date" [ngModel]="value" [attr.disabled]="disabled ? 'true' : null" (ngModelChange)="writeValue($event)" min="minDate" max="maxDate" >
